import React, { useState } from 'react';
import UserCard from './UserCard';
import { searchUsers } from '../services/api';

function Dashboard({ user }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    if (searchQuery.trim().length < 2) {
      setError('Please enter at least 2 characters to search');
      return;
    }

    setLoading(true);
    setError('');
    setSearched(true);

    try {
      const results = await searchUsers(searchQuery);
      setUsers(results);
    } catch (err) {
      setError('Failed to search users. Please try again.');
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    window.location.href = '/api/auth/logout';
  };

  const handleUserUpdate = (updatedUser) => {
    setUsers(users.map(u => u.id === updatedUser.id ? updatedUser : u));
  };

  return (
    <div className="dashboard">
      <header className="header">
        <div className="header-left">
          <img src="/SunPower_WhiteYellow.png" alt="SunPower Logo" className="header-logo" />
          <h1>Helpdesk Portal</h1>
        </div>
        <div className="header-right">
          <span className="user-info">Welcome, {user.name}</span>
          <button className="logout-btn" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      </header>

      <main className="main-content">
        <section className="search-section">
          <h2>Search Users</h2>
          <form className="search-form" onSubmit={handleSearch}>
            <input
              type="text"
              className="search-input"
              placeholder="Search by name or email..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              type="submit"
              className="search-btn"
              disabled={loading}
            >
              {loading ? 'Searching...' : 'Search'}
            </button>
          </form>
          {error && <p className="error-message" style={{ marginTop: '12px' }}>{error}</p>}
        </section>

        <section className="user-list">
          {loading && (
            <div className="loading-container" style={{ padding: '48px' }}>
              <div className="spinner"></div>
            </div>
          )}

          {!loading && searched && users.length === 0 && (
            <div className="no-results">
              <p>No users found matching "{searchQuery}"</p>
            </div>
          )}

          {!loading && users.map((u) => (
            <UserCard key={u.id} user={u} onUserUpdate={handleUserUpdate} />
          ))}
        </section>
      </main>
    </div>
  );
}

export default Dashboard;
